import React from 'react';
import styled from 'styled-components';
import { useLocale } from '../i18n/LocaleContext';

function Flag({ code }) {
  if (code === 'it') return <svg viewBox="0 0 30 20" aria-hidden="true">
    <path fill="#fff" d="M0 0h30v20H0z" />
    <path fill="#009246" d="M0 0h10v20H0z" />
    <path fill="#ce2b37" d="M20 0h10v20H20z" />
  </svg>;
  if (code === 'en') return <svg viewBox="0 0 30 20" aria-hidden="true">
    <path fill="#18366b" d="M0 0h30v20H0z" />
    <path stroke="#fff" strokeWidth="5" d="m0 0 30 20M30 0 0 20" />
    <path stroke="#c8102e" strokeWidth="2" d="m0 0 30 20M30 0 0 20" />
    <path stroke="#fff" strokeWidth="7" d="M15 0v20M0 10h30" />
    <path stroke="#c8102e" strokeWidth="4" d="M15 0v20M0 10h30" />
  </svg>;
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
    <circle cx="12" cy="12" r="9" /><ellipse cx="12" cy="12" rx="4" ry="9" /><path d="M3 12h18" />
  </svg>;
}

export default function LanguageSwitcher() {
  const { t, languages, locale, setLocale } = useLocale();
  return <Switcher role="group" aria-label={t('common.language')}>
    {languages.map(language => <LanguageButton key={language.code} type="button"
      aria-label={language.nativeName} title={language.nativeName} lang={language.code}
      aria-pressed={locale === language.code} onClick={() => setLocale(language.code)}>
      <FlagIcon><Flag code={language.code} /></FlagIcon>
      <span aria-hidden="true">{language.code.toUpperCase()}</span>
    </LanguageButton>)}
  </Switcher>;
}

const Switcher = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 3px;
  padding: 4px;
  border: 1px solid #dce8e7;
  border-radius: 999px;
  background: #f3f7f7;
`;

const LanguageButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 7px 10px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #586b6b;
  font: inherit;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: background 150ms ease, color 150ms ease, box-shadow 150ms ease;

  &[aria-pressed='true'] {
    background: white;
    color: #007d7c;
    box-shadow: 0 1px 5px rgb(20 65 65 / 12%);
  }
  &:hover { color: #006b6b; background: #e5efee; }
  &:focus-visible { outline: 2px solid #008c8c; outline-offset: 2px; }

  @media (max-width: 480px) {
    padding: 7px;
    gap: 5px;
  }
`;

const FlagIcon = styled.span`
  display: inline-flex;
  width: 22px;
  height: 15px;
  overflow: hidden;
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgb(0 0 0 / 6%);
  svg { width: 100%; height: 100%; }
`;
